import React, { useEffect, useState } from 'react';
import sanitizeHtml from 'sanitize-html';
const AiGeneratedReport = ({ finalScreen }: { finalScreen: string }) => {
  const [formatedReport, setFormatedReport] = useState<string>('');
  const [isHTML, setIsHTML] = useState<boolean>(false);

  function convertNewlinesToHTML(htmlPart) {
    const lines = htmlPart.split('\n');

    let result = '';
    let insideList = false;
    let listItems: string[] = [];

    lines.forEach(line => {
      const trimmed = line.trim();

      if (/^\d+\.\s+/.test(trimmed)) {
        insideList = true;
        listItems.push(trimmed.replace(/^\d+\.\s+/, ''));
      } else {
        if (insideList) {
          result += '<ol>' + listItems.map(item => `<li>${item}</li>`).join('') + '</ol>';
          listItems = [];
          insideList = false;
        }
        if (trimmed !== '') {
          result += `<p>${trimmed}</p>`;
        }
      }
    });

    if (insideList && listItems.length > 0) {
      result += '<ol>' + listItems.map(item => `<li>${item}</li>`).join('') + '</ol>';
    }

    return result;
  }

  useEffect(() => {
    const result = sanitizeHtmlForPDF(finalScreen);
    setFormatedReport(result);
  }, [finalScreen]);

  function formatDate(value: string): string {
    const parsed = Date.parse(value);
    return !isNaN(parsed)
      ? new Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }).format(new Date(parsed))
      : value;
  }
  function sanitizeHtmlForPDF(finalScreen: string): string {
    if (!finalScreen) return '';
    const seenLabelValue = new Set<string>();
    const evidenceStartPattern = /\n\n\n\s*Date:/;
    const evidenceStartIndex = finalScreen.search(evidenceStartPattern);
    const plainTextPart = evidenceStartIndex !== -1 ? finalScreen.slice(0, evidenceStartIndex).trim() : finalScreen;
    const evidencePart = evidenceStartIndex !== -1 ? finalScreen.slice(evidenceStartIndex).trim() : '';

    const fieldHtmlBlocks: string[] = [];
    const evidenceDetails: string[] = [];
    const customEvidenceBlock = `
    <h3 style="font-size:1.4rem;font-weight:bold;margin-top:1em;color:#111;">
      Collected Evidence
    </h3>
  `;

    let firstIncidentDate = '';
    let latestIncidentDate = '';
    let discriminationType = '';
    const dateLabels = ['Date of the 1st incident', 'Date of latest incident', 'Date of the first incident', 'Date of incident', 'Date'];
    let questionNumber = 1;
    const lines = plainTextPart.split('\n').filter(line => line.trim());
    lines.forEach(rawLine => {
      const cleanText = rawLine
        .replace(/<[^>]+>/g, '')
        .replace(/[*#]/g, '')
        .trim();
      const lower = cleanText.toLowerCase();
      if (!cleanText || lower === 'null') return;
      if (rawLine.trim().startsWith('**') && rawLine.trim().endsWith('**')) {
        const headingText = rawLine
          .replace(/```[a-zA-Z]*[\s\S]*?```/g, '')
          .replace(/\*/g, '')
          .trim();
        fieldHtmlBlocks.push(`<h2 style="font-size:1.3rem;font-weight:bold;margin-top:1em;color:#111;">${headingText}</h2>`);
        return;
      }
      if (lower.startsWith('type of discrimination')) {
        discriminationType = cleanText.split(':(:ans:)')[1]?.trim() || '';
      } else if (lower.startsWith('date of the 1st incident')) {
        firstIncidentDate = cleanText.split(':(:ans:)')[1]?.trim() || '';
      } else if (lower.startsWith('date of latest incident')) {
        latestIncidentDate = cleanText.split(':(:ans:)')[1]?.trim() || '';
      }
      if (cleanText.includes(':') && !cleanText.startsWith('-')) {
        const [label, ...rest] = cleanText.split(':(:ans:)');
        const rawValue = rest.join(':').trim();
        const key = `${label.trim()}:${rawValue}`;
        if (!rawValue || seenLabelValue.has(key)) return;

        seenLabelValue.add(key);
        const formattedLabel = label.trim();
        let formattedValue = rawValue;
        if (/^\d+(\.\s|\))/m.test(formattedValue)) {
          formattedValue = formattedValue
            .split(/\n+/)
            .map(line => line.trim())
            .filter(Boolean)
            .join('<br/>');
        }
        if (dateLabels.some(dl => formattedLabel.toLowerCase().includes(dl.toLowerCase()))) {
          formattedValue = formatDate(formattedValue);
        }

        const fieldBlock = `
        <div style="margin-bottom:10px; display:grid; grid-template-columns: auto 1fr; column-gap:5px;">
  <div style="font-weight:bold; color:rgb(34, 34, 34);">${questionNumber}.</div>
  <div style="font-weight:bold; color:rgb(34, 34, 34);">${formattedLabel}</div>

  <div></div>
  <div style="font-size:16px; font-weight:400; color:rgba(79, 79, 79, 0.8);">
    ${formattedValue}
  </div>
</div>
      `;
        fieldHtmlBlocks.push(fieldBlock);
        questionNumber++;
      }
    });
    if (evidencePart.startsWith('Date:')) {
      const evidenceBlocks = evidencePart.split(/\n(?=Date:)/).filter(block => block.trim());
      evidenceDetails.push(customEvidenceBlock);

      let exhibit = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      let exhibitIndex = 0;

      evidenceBlocks.forEach(block => {
        const currentEvidence: { [key: string]: string | boolean } = {};
        const relevanceMatch = block.match(/Relevance:\s*([\s\S]*?)(?=(?:\nFile Type:|\nFile Name:|$))/); //remove date
        if (relevanceMatch) {
          let relevanceText = relevanceMatch[1].trim();

          if (relevanceText) {
            const lines = relevanceText
              .split(/\n+/)
              .map(l => l.trim())
              .filter(Boolean);

            if (lines.length === 1) {
              relevanceText = lines[0];
              currentEvidence['RelevanceInline'] = true;
            } else {
              relevanceText = lines.join('<br/>');
              currentEvidence['RelevanceInline'] = false;
            }
          }

          currentEvidence['Relevance'] = relevanceText;
          const dateMatch = block.match(/Date:\s*([^\n]+)/);
          const typeMatch = block.match(/File Type:\s*([^\n]+)/);
          const fileNameMatch = block.match(/File Name:\s*([^\n]+)/);

          if (dateMatch) currentEvidence['Date'] = dateMatch[1].trim();
          if (typeMatch) currentEvidence['File Type'] = typeMatch[1].trim();
          if (fileNameMatch) currentEvidence['File Name'] = fileNameMatch[1].trim();
          evidenceDetails.push(`
          <h4 style="margin-top:20px;color:#111;"> Exhibit ${exhibit[exhibitIndex]}</h4>
        <div style="
          display:flex;
          flex-wrap:wrap;
          gap:10px;
          align-items:flex-start;
          padding:8px 12px;
          border-bottom:1px solid #ddd;
        ">
          <div style="flex:1 1 150px; min-width:150px;">
            <strong>Date:</strong> ${currentEvidence['Date'] || ''}
          </div>
          <div style="flex:1 1 200px; min-width:150px;">
            <strong>Relevance:</strong>
            ${currentEvidence['RelevanceInline'] ? ' ' : '<br/>'}
            ${currentEvidence['Relevance'] || ''}
          </div>
          <div style="flex:1 1 120px; min-width:120px;">
            <strong>File Type:</strong> ${currentEvidence['File Type'] || ''}
          </div>
          <div style="flex:2 1 250px; min-width:180px; word-break:break-word;">
            <strong>File Name:</strong> ${currentEvidence['File Name'] || ''}
          </div>
        </div>
      `);

          exhibitIndex++;
        }
      });
    }
    const headerHtml = `
    <h1 style="font-size:1.5rem;font-weight:bold;color:#222;text-align:center;">
      ${discriminationType || 'Discrimination'} Report
    </h1>
   
    ${
      firstIncidentDate && latestIncidentDate
        ? `<p style="text-align:center;margin-bottom:1em;font-size:0.95rem;">
            Dates: ${formatDate(firstIncidentDate)} to ${formatDate(latestIncidentDate)}
          </p>`
        : ' <p style="text-align:center;margin-bottom:2em;font-size:0.95rem;"></p>'
    }
  `;
    return `
    ${headerHtml}
    ${fieldHtmlBlocks.join('\n')}
    ${evidenceDetails.join('\n')}
  `.trim();
  }

  // function sanitizeHtmlForPDF(finalScreen: string): string {
  //   if (!finalScreen) return '';

  //   const seenLabelValue = new Set<string>();
  //   const htmlStartIndex = finalScreen.indexOf('Date');
  //   const plainTextPart = htmlStartIndex !== -1 ? finalScreen.slice(0, htmlStartIndex).trim() : finalScreen;
  //   const htmlPart = htmlStartIndex !== -1 ? finalScreen.slice(htmlStartIndex) : '';
  //   const preprocessedHtml = htmlPart.replace(/\n/g, '');
  //   const htmlWithNewlines = convertNewlinesToHTML(htmlPart);
  //   let rawHTML = htmlWithNewlines;
  //   rawHTML = htmlWithNewlines
  //     .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
  //     .replace(/(?<!\*)\*(?!\*)(.*?)\*(?!\*)/g, '<em>$1</em>')
  //     .replace(/\\\*/g, '');

  //   rawHTML = rawHTML.replace(/\*/g, '');
  //   const cleanHTML = sanitizeHtml(rawHTML, {
  //     allowedTags: ['h1', 'h2', 'h3', 'p', 'strong', 'em', 'ul', 'ol', 'li', 'br'],
  //     allowedAttributes: {
  //       '*': [],
  //     },
  //     disallowedTagsMode: 'discard',
  //   });

  //   let cleanedHtml = htmlPart
  //     .replace(/<\s*\/?\s*(html|head|title|style|body|meta|link|script)[^>]*>/gi, '')
  //     .replace(/<!DOCTYPE[^>]*>/gi, '')
  //     .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
  //     .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
  //     .replace(/\s*style="[^"]*"/gi, '')
  //     .replace(/(?<!\*)\*(?!\*)(.*?)\*(?!\*)/g, '<em>$1</em>')
  //     .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
  //     .replace(/```[a-zA-Z]*[\s\S]*?```/g, '')
  //     .replace(/&lt;style[^&]*&gt;.*?&lt;\/style&gt;/gis, '')
  //     .replace(/<style[^>]*>.*?<\/style>/gis, '')
  //     .trim();

  //   const fieldHtmlBlocks: string[] = [];
  //   const evidenceDetails: string[] = [];

  //   let firstIncidentDate = '';
  //   let latestIncidentDate = '';
  //   let discriminationType = '';
  //   const dateLabels = ['Date of the 1st incident', 'Date of latest incident', 'Date of the first incident', 'Date of incident', 'Date'];

  //   const lines = plainTextPart.split('\n').filter(line => line.trim());
  //   lines.forEach(rawLine => {
  //     const cleanText = rawLine
  //       .replace(/<[^>]+>/g, '')
  //       .replace(/[*#]/g, '')
  //       .trim();
  //     const lower = cleanText.toLowerCase();
  //     if (!cleanText || lower === 'null') return;

  //     if (rawLine.trim().startsWith('**') && rawLine.trim().endsWith('**')) {
  //       const headingText = rawLine
  //         .replace(/```[a-zA-Z]*[\s\S]*?```/g, '')
  //         .replace(/\*/g, '')
  //         .trim();
  //       fieldHtmlBlocks.push(`<h2 style="font-size:1.3rem;font-weight:bold;margin-top:1em;color:#111;">${headingText}</h2>`);
  //       return;
  //     }

  //     if (lower.startsWith('type of discrimination')) {
  //       discriminationType = cleanText.split(':')[1]?.trim() || '';
  //     } else if (lower.startsWith('date of the 1st incident')) {
  //       firstIncidentDate = cleanText.split(':')[1]?.trim() || '';
  //     } else if (lower.startsWith('date of latest incident')) {
  //       latestIncidentDate = cleanText.split(':')[1]?.trim() || '';
  //     }

  //     if (cleanText.includes(':') && !cleanText.startsWith('-')) {
  //       const [label, ...rest] = cleanText.split(':');
  //       const rawValue = rest.join(':').trim();
  //       const key = `${label.trim()}:${rawValue}`;
  //       if (!rawValue || seenLabelValue.has(key)) return;

  //       seenLabelValue.add(key);
  //       const formattedLabel = label.trim();
  //       let formattedValue = rawValue;

  //       if (dateLabels.some(dl => formattedLabel.toLowerCase().includes(dl.toLowerCase()))) {
  //         formattedValue = formatDate(formattedValue);
  //       }

  //       const fieldBlock = `
  //         <div style="margin-bottom:10px;">
  //           <div style="font-weight:bold;margin-bottom:5px;color:rgb(34, 34, 34);">${formattedLabel}</div>
  //           <div style="margin-bottom:4px;font-size: 16px;font-weight: 400;color:rgba(79, 79, 79, 0.8);">${formattedValue}</div>
  //         </div>
  //       `;
  //       fieldHtmlBlocks.push(fieldBlock);
  //     }
  //   });

  //   const headerHtml = `
  //     <h1 style="font-size:1.8rem;font-weight:bold;color:#222;text-align:center;">
  //       ${discriminationType || 'Discrimination'} Report
  //     </h1>
  //     ${
  //       firstIncidentDate && latestIncidentDate
  //         ? `<p style="text-align:center;margin-bottom:1em;font-size:0.95rem;">
  //             Dates: ${formatDate(firstIncidentDate)} to ${formatDate(latestIncidentDate)}
  //           </p>`
  //         : ''
  //     }
  //   `;

  //   const cleanData = cleanedHtml.split('\n').filter(line => line.trim());
  //   cleanData.forEach(rawLine => {
  //     const cleanText = rawLine
  //       .replace(/<[^>]+>/g, '')
  //       .replace(/[*#]/g, '')
  //       .replace(/[*#]/g, '')
  //       .trim();
  //     const lower = cleanText.toLowerCase();

  //     if (!cleanText || lower === 'null') return;

  //     if (rawLine.trim().startsWith('**') && rawLine.trim().endsWith('**')) {
  //       const headingText = rawLine.replace(/\*/g, '').trim();
  //       evidenceDetails.push(`<h2 style="font-size:1.3rem;font-weight:bold;margin-top:1em;color:#111;">${headingText}</h2>`);
  //     } else if (['Conclusion', 'Key Points', 'Collected Evidence'].includes(cleanText)) {
  //       evidenceDetails.push(`<h4 style="font-size:1rem;font-weight:bold;margin-top:1em;color:#111;">${cleanText}</h4>`);
  //     } else {
  //       const cleanedParagraph = rawLine
  //         .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
  //         .replace(/style="[^"]*"/gi, '')
  //         .replace(/<em>\s*\*+\s*<\/em>/gi, '')
  //         .replace(/<[^>]+>/g, '')
  //         .replace(/^[\s*#-]+/, '')
  //         .replace(/(?<!\*)\*(?!\*)(.*?)\*(?!\*)/g, '<em>$1</em>')
  //         .replace(/[*]+$/g, '')
  //         .trim();
  //       evidenceDetails.push(`<p style="font-size:0.95rem;">${cleanedParagraph}</p>`);
  //     }
  //   });

  //   return `
  //     ${headerHtml}
  //     ${fieldHtmlBlocks.join('\n')}
  //     ${evidenceDetails.join('\n')}
  //   `.trim();

  //   return `
  //     ${headerHtml}
  //     ${fieldHtmlBlocks.join('\n')}
  //     <div>
  //   ${
  //     cleanHTML
  //       ? cleanHTML
  //           .replace(/```[a-zA-Z]*[\s\S]*?```/g, '')
  //           .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
  //           .replace(/(?<!\*)\*(?!\*)(.*?)\*(?!\*)/g, '<em>$1</em>')
  //       : evidenceDetails.join('\n')
  //   }
  // </div>
  //   `.trim();
  // }

  return (
    <div style={{ padding: '10px', backgroundColor: '#fff' }}>
      <div className="logo-icon p-0 report-section" style={{ textAlign: 'center' }}>
        <img src="content/images/cases/dyhaclogo.svg" alt="Logo" style={{ maxWidth: '50px' }} />
      </div>

      <div
        className="pdf-report-style report-section"
        style={{ maxWidth: '750px', margin: '0 auto' }}
        dangerouslySetInnerHTML={{ __html: formatedReport }}
      />
    </div>
  );
};

export default AiGeneratedReport;
